import React from 'react';
import { connect } from 'react-redux';

import { changeSlideWithNoLoadMore } from '../redux/actions/placesModalActions';
import { orderedArray, arrayForModal } from '../screens/Trek/utils';

export default function withDayArray(ModalSlider) {
  const mapStateToProps = state => {
    const {
      placesModal: { slideIndex },
      servicesModal: {
        patchInfo: { dayNo, index },
      },
      schema: { days },
    } = state;
    const route = days.byId[dayNo].routes[index];
    let sortedArray = [];
    let themeType = '';
    let themes = [];

    sortedArray = route.posters && orderedArray(route.posters);

    themes = arrayForModal(sortedArray);

    themeType = themes[slideIndex].poster_type;

    return {
      themes,
      slideIndex,
      themeType,
    };
  };

  const mapDispatchToProps = dispatch => () => ({
    changeSlide: (slideTo, slideIndex) => {
      dispatch(changeSlideWithNoLoadMore({ slideTo, slideIndex }));
    },
  });

  const DayModalSlider = props => <ModalSlider {...props} />;

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(DayModalSlider);
}



// WEBPACK FOOTER //
// ./src/HOCs/withDayArray.jsx